export default "__VITE_ASSET__ppfJJ1Ir__"